import { AlignLeft, type LucideIcon } from 'lucide-react';

export const TextIcon: LucideIcon = AlignLeft;
